import { ClipboardList, Globe2, Instagram, MessageCircle } from 'lucide-react';

export function CampaignDestinations({ labels }: { labels: string[] }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {labels.map((label) => {
        const Icon =
          label === 'Lead form'
            ? ClipboardList
            : label === 'Website'
              ? Globe2
              : label === 'Instagram DMs'
                ? Instagram
                : MessageCircle;
        return (
          <span
            key={label}
            className="inline-flex items-center gap-1.5 rounded-md bg-muted/70 px-2 py-1 text-xs font-medium text-muted-foreground"
          >
            <Icon aria-hidden className="size-3.5 shrink-0" />
            {label}
          </span>
        );
      })}
    </div>
  );
}
